import { useRoute } from 'vue-router'
import { usePackage } from '@core/composables/usePackage'
import { reactive, watch, computed } from 'vue'

const state = reactive({
  packagePriceId: null,
  creditOnly: false,
})

const PREFIX_STORAGE_KEY = 'ereleases'

const IS_MAIN_STORAGE_KEY = `${PREFIX_STORAGE_KEY}_isMain`
const SPECIAL_PACKAGE_STORAGE_KEY = `${PREFIX_STORAGE_KEY}_specialPackage`

const useSpecialPackage = () => {
  const route = useRoute()
  const packageSlug = computed(() => route.params.packageSlug)

  const { packageItem, isLoading: packageLoading } = usePackage(packageSlug)

  const isLoading = computed(() =>
    packageSlug.value ? packageLoading.value : false
  )

  watch(packageItem, (loadedPackageItem) => {
    if (!packageSlug.value || !loadedPackageItem?.id) return

    state.packagePriceId = loadedPackageItem?.singleCreditPrice?.id
    state.creditOnly = loadedPackageItem?.creditOnly

    localStorage.setItem(`${IS_MAIN_STORAGE_KEY}`, loadedPackageItem?.main)
    localStorage.setItem(
      `${SPECIAL_PACKAGE_STORAGE_KEY}`,
      JSON.stringify(loadedPackageItem)
    )
  })

  return { packageItem, isLoading }
}

const clearState = () => {
  state.packagePriceId = null
}

export {
  state,
  useSpecialPackage,
  clearState,
  IS_MAIN_STORAGE_KEY,
  SPECIAL_PACKAGE_STORAGE_KEY,
}
